module.exports = __webpack_public_path__ + "media/images/awards/gold-sparkle-788dcf023b93bfd17aad4cde1cab857a.png";